// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Report / Chart Library data tables — imported after index.css so these rules
 * always win over Tailwind utilities and body 16px inheritance.
 */
.data-table-chart-report,
.data-table-chart-report table,
.data-table-chart-report tbody td {
  font-size: 14px !important;
  line-height: 1.25 !important;
}

.data-table-chart-report thead th {
  font-size: 12px !important;
  line-height: 1.25 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/reportTable.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B","sourcesContent":["/**\n * Report / Chart Library data tables — imported after index.css so these rules\n * always win over Tailwind utilities and body 16px inheritance.\n */\n.data-table-chart-report,\n.data-table-chart-report table,\n.data-table-chart-report tbody td {\n  font-size: 14px !important;\n  line-height: 1.25 !important;\n}\n\n.data-table-chart-report thead th {\n  font-size: 12px !important;\n  line-height: 1.25 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
